import { Box, BoxProps, Typography } from "@mui/material";
import { TablePlaceHolder } from "@app/components/PlaceHolder";
import { memo, useMemo, useState } from "react";
import {
  FlatPageRouteControl,
  FlatPageRouteTab,
} from "@app/components/FlatPageRouteControl";
import { SimulationModelsModels } from "./SimulationModelsModels";
import { SimulationModelsRun } from "./SimulationModelsRun";
import { SimulationModelsBehavior } from "./SimulationModelsBehavior";
import { CarSelectOptionField } from "@app/components/Inputs";
import { CarModuleSectionCode } from "@app/hooks/useUserAccess";
import { SimulationModelsBoundaries } from "./SimulationModelsBoundaries";
import { SimulationModelsHistory } from "./SimulationModelsHistory";
import { SimulationModelsIndexCompare } from "./SimulationModelsIndexCompare";

interface PagesProps {
  sx?: BoxProps["sx"];
  isStatic: boolean;
}

const Pages = (props: PagesProps) => {
  const tabs = useMemo<Array<FlatPageRouteTab>>(() => {
    const result: FlatPageRouteTab[] = props.isStatic
      ? [
          {
            url: "models",
            label: "Models",
            moduleSection:
              CarModuleSectionCode.SIMULATION_ANALYSIS_MODELS_MODELS,
            content: <SimulationModelsModels isStatic={true} />,
          },
          {
            url: "boundaries",
            label: "Boundaries",
            moduleSection:
              CarModuleSectionCode.SIMULATION_ANALYSIS_MODELS_BOUNDARY,
            content: <SimulationModelsBoundaries />,
          },
          {
            url: "behavior",
            label: "Behavior",
            moduleSection:
              CarModuleSectionCode.SIMULATION_ANALYSIS_MODELS_BEHAVIOR,
            content: <SimulationModelsBehavior isStatic={true} />,
          },
          {
            url: "history",
            label: "History",
            moduleSection:
              CarModuleSectionCode.SIMULATION_ANALYSIS_MODELS_HISTORY,
            content: <SimulationModelsHistory />,
          },
        ]
      : [
          {
            url: "models",
            label: "Models",
            moduleSection:
              CarModuleSectionCode.SIMULATION_ANALYSIS_MODELS_MODELS,
            content: <SimulationModelsModels isStatic={false} />,
          },
          {
            url: "boundaries",
            label: "Boundaries",
            moduleSection:
              CarModuleSectionCode.SIMULATION_ANALYSIS_MODELS_BOUNDARY,
            content: <SimulationModelsBoundaries />,
          },
          {
            url: "behavior",
            label: "Behavior",
            moduleSection:
              CarModuleSectionCode.SIMULATION_ANALYSIS_MODELS_BEHAVIOR,
            content: <SimulationModelsBehavior isStatic={false} />,
          },
          {
            url: "index-compare",
            label: "Index Compare",
            moduleSection:
              CarModuleSectionCode.SIMULATION_ANALYSIS_MODELS_INDEX_COMPARE,
            content: <SimulationModelsIndexCompare />,
          },
          {
            url: "history",
            label: "History",
            moduleSection:
              CarModuleSectionCode.SIMULATION_ANALYSIS_MODELS_HISTORY,
            content: <SimulationModelsHistory />,
          },
          {
            url: "run",
            label: "Run",
            moduleSection: CarModuleSectionCode.SIMULATION_ANALYSIS_MODELS_RUN,
            content: <SimulationModelsRun />,
          },
        ];

    return result;
  }, [props.isStatic]);
  return <FlatPageRouteControl tabs={tabs} sx={props.sx} />;
};

export const SimulationModels = memo(() => {
  const [capitalMarketAssumptions, setCapitalMarketAssumptions] = useState<
    string | undefined
  >("price-driven");
  return (
    <TablePlaceHolder sx={{ mx: 7, mt: 10 }} isLoading={false} rows={8}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        <Typography variant="h2SSemiBold" sx={{ mt: 4 }}>
          Models
        </Typography>
        <Typography variant="mediumItalic">
          Source Data as of: MM/DD/YYYY
        </Typography>
      </Box>
      <CarSelectOptionField
        sx={{ alignSelf: "flex-start", mt: 3.5, minWidth: 300 }}
        label="Capital Market Assumptions"
        value={capitalMarketAssumptions}
        onChange={setCapitalMarketAssumptions}
        options={[
          {
            label: "Price - Driven Model",
            value: "price-driven",
          },
          {
            label: "Static Model",
            value: "static",
          },
        ]}
      />
      <Pages sx={{ mt: 3 }} isStatic={capitalMarketAssumptions === "static"} />
    </TablePlaceHolder>
  );
});
